import Vue from 'vue'
import Router from 'vue-router'

const StartPage = () => import(/* webpackChunkName: "app-module */ '@/Components/Modules/StartPage')
const TextModule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/TextModule')
const Stream = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/Stream')
const RssFeed = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/RssFeed')
const Team = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/Team')
const ImageGallery = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/ImageGallery')
const FormModule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/FormModule')
const Dummy = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/Dummy')
const Facebook = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/Facebook')
const Twitter = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/Twitter')
const YoutubeModule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/YoutubeModule')
const WebsiteMdoule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/WebsiteModule')
const ChatModule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/ChatModule')
const Instagram = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/Instagram')
const CustomCodeModule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/CustomCodeModule')
const PdfModule = () => import(/* webpackChunkName: "app-module" */ '@/Components/Modules/PdfModule')

Vue.use(Router)

const requireAuth = (to, from, next) => {
  let user = JSON.parse(sessionStorage.getItem('user'))
  if (user && user.Authenticated) {
    next()
  } else {
    next({ name: 'login' })
  }
}

const redirectToPathIfNoParam = (path, parameKey) => {
  return (to, from, next) => {
    if (to.params && to.params[parameKey]) {
      next()
    } else {
      next({ path: path })
    }
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/account'
    },
    {
      name: 'account',
      path: '/account',
      redirect: '/account',
      component: () => import('@/components/Views/Account'),
      children: [
        {
          path: '',
          redirect: 'login'
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('@/components/account/Login')
        },
        {
          path: 'forgotpassword',
          name: 'forgotpassword',
          component: () => import('@/components/account/ResetPassword')
        }
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/components/Views/NewDashboard'), // Dashboard,
      title: 'Dashboard',
      beforeEnter: requireAuth
    },
    {
      path: '/appdesigner',
      name: 'appdesigner',
      component: () => import('@/components/Views/NewAppDesigner'), // AppDesigner,
      title: 'Design',
      beforeEnter: requireAuth
    },
    {
      path: '/expire',
      name: 'expire',
      component: () => import('@/components/Views/TrialExpire')
    },
    {
      path: '/createapp',
      name: 'createapp',
      component: () => import('@/components/Views/CreateApp'), // CreateApp,
      title: 'CreateApp'
    },
    {
      path: '/order/:serviceType/:clientId?',
      // path: '/order/:clientId/:serviceType?',
      query: { id: 'id' },
      name: 'orderservice',
      component: () => import('@/components/Views/OrderProcessService'), // OrderProcessService,
      title: 'Order Service',
      props: true
    },
    {
      path: '/orderNew/:serviceType/:clientId?',
      // path: '/order/:clientId/:serviceType?',
      query: { id: 'id' },
      name: 'orderserviceNew',
      component: () => import('@/components/NewOrderProcess/SubscriptionLevels/NewProducts'), // OrderProcessService,
      title: 'Order Service',
      props: true
    },
    {
      path: '/ordersuccessview/:serviceType/:clientId?',
      name: 'ordersuccessview',
      component: () => import('@/components/NewOrderProcess/NewOrderSuccess'), // NewOrderSuccess,
      title: 'Order Success View'
    },
    {
      path: '/orderErrorview/:serviceType/:clientId?',
      name: 'orderErrorview',
      component: () => import('@/components/NewOrderProcess/NewOrderError'), // NewOrderError,
      title: 'Order Error View'
    },
    {
      path: '/orderpublishview/:serviceType/:clientId?',
      name: 'orderpublishview',
      component: () => import('@/components/NewOrderProcess/PublishService'), // PublishService,
      title: 'Order Publish Service'
    },
    {
      name: 'editcontent',
      title: 'Content',
      path: '/editcontent',
      // redirect: '/editcontent',
      component: () => import('@/components/Views/NewAppContent'), // AppContent,
      beforeEnter: requireAuth,
      props: true,
      children: [
        // {
        //   path: '',
        //   redirect: 'startpage',
        //   props: true
        // },
        {
          name: 'startpage',
          path: 'startpage',
          component: StartPage,
          props: true
        },
        {
          name: 'text',
          path: 'text/:SubscriptionModuleId?',
          component: TextModule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'stream',
          path: 'stream/:SubscriptionModuleId?',
          component: Stream,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'rss-feeds',
          path: 'rss-feeds/:SubscriptionModuleId?',
          component: RssFeed,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'team',
          path: 'team/:SubscriptionModuleId?',
          component: Team,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'facebook',
          path: 'facebook/:SubscriptionModuleId?',
          component: Facebook,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'twitter',
          path: 'twitter/:SubscriptionModuleId?',
          component: Twitter,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'imagegallery',
          path: 'imagegallery/:SubscriptionModuleId?',
          component: ImageGallery,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'pdf-files',
          path: 'pdf-files/:SubscriptionModuleId?',
          component: PdfModule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'form-module',
          path: 'form-module/:SubscriptionModuleId?',
          component: FormModule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'youtube',
          path: 'youtube/:SubscriptionModuleId?',
          component: YoutubeModule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'website',
          path: 'website/:SubscriptionModuleId?',
          component: WebsiteMdoule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'chat',
          path: 'chat/:SubscriptionModuleId?',
          component: ChatModule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'instagram',
          path: 'instagram/:SubscriptionModuleId?',
          component: Instagram,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'custom-code-module',
          path: 'custom-code-module/:SubscriptionModuleId?',
          component: CustomCodeModule,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        },
        {
          name: 'dummy',
          path: 'dummy/:SubscriptionModuleId?',
          component: Dummy,
          props: true,
          beforeEnter: redirectToPathIfNoParam('/dashboard', 'SubscriptionModuleId')
        }
      ]
    },
    {
      path: '/publish',
      name: 'publish',
      component: () => import('@/components/Views/PublishService'), // PublishService,
      title: 'Publish App',
      beforeEnter: requireAuth
    },
    {
      path: '/notification',
      name: 'notification',
      component: () => import('@/components/Views/Notification'), // Notification,
      title: 'Notification',
      beforeEnter: requireAuth
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('@/components/Views/FeedbackService'), // FeedbackService,
      title: 'feedback',
      beforeEnter: requireAuth
    },
    {
      path: '/inviteuser',
      name: 'inviteuser',
      component: () => import('@/components/Views/UserManagement'), // UserManagement,
      title: 'inviteuser',
      beforeEnter: requireAuth
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('@/components/Views/AnalyticsService'), // AnalyticsService,
      title: 'Analytics',
      beforeEnter: requireAuth
    },
    {
      path: '/accountsettings',
      name: 'accountsettings',
      component: () => import('@/components/Views/AccountSetting'), // AnalyticsService,
      title: 'Account Setting',
      beforeEnter: requireAuth
    },
    {
      path: '/styleguide',
      name: 'styleguide',
      component: () => import('@/components/layouts/BaseLayout')
    },
    {
      path: '/registrationcompleted',
      name: 'registrationcompleted',
      component: () => import('@/components/Views/RegistrationCompleted')
    },
    {
      path: '*',
      name: 'nofound',
      component: () => import('@/components/Views/NotFound'), // NotFound,
      title: 'Not Found'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js